import { render, staticRenderFns } from "./AutomazioneLogs.vue?vue&type=template&id=21194e46&"
import script from "./AutomazioneLogs.vue?vue&type=script&lang=js&"
export * from "./AutomazioneLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports